// extracted by mini-css-extract-plugin
export default {"cls1":"PostPrompt-cls1_w68","cls2":"PostPrompt-cls2_CrW PostPrompt-cls1_w68"};